import React, { useState } from 'react';
import { PlusIcon, MinusIcon } from 'lucide-react';
const faqs = [{
  q: 'Isn’t there a free chess curriculum online already?',
  a: 'There are free lessons and curriculums. What’s not free is a whole season already scripted, timed and print-ready — no sign-up forms, no rigid school pacing, no assembling sessions from scattered PDFs. You’re not paying for lessons, you’re paying to never build a session from scratch again.'
}, {
  q: 'I’m not a strong player. Can I still teach this?',
  a: 'Yes — it’s built for exactly that. Every session is written word for word with coach cues in brackets, Volume 1 includes a quick-start for running your first session with zero chess background, and the Rules & Questions Cheat-Sheet gives you the exact answer when a kid asks “is that legal?”'
}, {
  q: 'Will it fit my group’s level?',
  a: 'Every session comes in three levels — beginner, improver and ready-to-play — so the same plan works for a room of first-timers or a mixed group. The Start Here Club Launch Map tells you which path to start on.'
}, {
  q: 'Our meetings are short. Does that work?',
  a: 'Yes. Every session plan comes in three lengths: Short (20 min), Standard (45 min) and Full (60 min). Pick the one that fits your time slot.'
}, {
  q: 'We only have a few boards. Is that a problem?',
  a: 'No. Every volume has a “big club, few boards” page for running sessions with 30 kids and 8 sets, and the No-Equipment Club Kit bonus gives you a printable board and cut-out pieces.'
}, {
  q: 'I don’t have time to read 300 pages. Do I have to?',
  a: 'No. You don’t read it cover to cover — you open it to today’s session and teach that one. The Start Here map points you to your first four weeks in about thirty seconds.'
}, {
  q: 'Is it printable or digital only?',
  a: 'Digital PDFs, laid out for printing. Most coaches print the worksheets for the day and keep the session plan open on a tablet or printed on the desk.'
}, {
  q: 'How do I get it?',
  a: 'Instant download after checkout, plus an email with your files. Lifetime access to what you bought.'
}];
export function Faq() {
  const [open, setOpen] = useState<number | null>(null);
  return <section aria-labelledby="faq-heading" className="w-full bg-ice text-ink" data-id="element-80" data-mp="1koow8r1uo2dh">
      <div className="max-w-3xl mx-auto px-5 py-16 sm:py-20" data-id="element-81" data-mp="1ftrqbszva94t">
        <div className="text-center" data-id="element-82" data-mp="2dfyu50ocjxg4">
          <p className="text-[11px] font-bold uppercase tracking-[1.6px] text-gold-deep" data-id="element-83" data-mp="2dexf6l47mqt4">
            Before you buy
          </p>
          <h2 id="faq-heading" className="chalk-underline mt-3 font-display text-ink text-[28px] sm:text-5xl" data-id="element-84" data-mp="23hj471122u87">
            Frequently asked questions
          </h2>
        </div>

        <div className="mt-8 grid gap-2.5" data-id="element-85" data-mp="s2vpy7hci5ly">
          {faqs.map((faq, i) => {
          const isOpen = open === i;
          return <div key={faq.q} className="overflow-hidden rounded-xl border border-ice-dark bg-white" data-id="element-86" data-mp="nz7jjs4g9g2a" data-mpi={i}>
                <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 px-4 py-4 text-left text-[15px] font-bold text-ink focus:outline-none focus-visible:ring-2 focus-visible:ring-gold-deep" data-id="element-87" data-mp="33pfygoqefgaa">
                  {faq.q}
                  {isOpen ? <MinusIcon className="h-5 w-5 flex-none text-gold-deep" aria-hidden="true" data-id="element-88" data-mp="3ncdpl6pvssmd" /> : <PlusIcon className="h-5 w-5 flex-none text-gold-deep" aria-hidden="true" data-id="element-89" data-mp="3rg3a9l3fqq24" />}
                </button>
                {isOpen && <p className="px-4 pb-4 text-sm text-ink-soft" data-id="element-90" data-mp="1x2c3qugekmaw">{faq.a}</p>}
              </div>;
        })}
        </div>
      </div>
    </section>;
}